__turbopack_context__.v({
  "root": "HDpz2W_root",
});
